import ChevronUpIcon from '@heroicons/react/outline/esm/ChevronUpIcon.js'
import ThumbUpIcon from '@heroicons/react/solid/esm/ThumbUpIcon.js'
import { clsx } from 'clsx'

import {
  PostReactionDetail,
  ReactionType,
} from '@tribeplatform/gql-client/types'
import { IconButton } from '@tribeplatform/react-ui-kit/Button'

import { IconEmoji } from '../common/components/IconEmoji.js'

export const Reaction = ({
  reaction,
  reactionType,
  onClick,
  label,
}: {
  reaction: PostReactionDetail
  reactionType: ReactionType
  onClick?: (reaction: PostReactionDetail) => void
  label?: string
}) => {
  switch (reactionType) {
    case ReactionType.LIKE_BASE:
      return (
        <IconButton
          size="sm"
          variant="secondary"
          pressed={reaction.reacted}
          icon={<ThumbUpIcon />}
          onClick={() => {
            onClick?.(reaction)
          }}
          aria-label={label}
        />
      )
    case ReactionType.VOTE_BASE:
      return (
        <IconButton
          size="sm"
          variant="secondary"
          pressed={reaction.reacted}
          onClick={() => {
            onClick?.(reaction)
          }}
          aria-label={label}
          icon={<ChevronUpIcon />}
        />
      )
    case ReactionType.EMOJI_BASE:
    default:
      return (
        <button
          type="button"
          className={clsx(
            'rounded-full w-9 h-7 text-lg border-2 border-line-subdued -me-1.5 flex items-center justify-center overflow-hidden',
            'bg-surface-pressed hover:bg-skeleton',
            'ring-surface ring-1 ring-offset-0',
          )}
          onClick={() => {
            onClick?.(reaction)
          }}
          aria-label={label}
        >
          <IconEmoji text={reaction.reaction} />
        </button>
      )
  }
}
